import { PaletteDesignToken } from '@primeuix/themes/types';

export const DARK_MODE_CLASS = 'app-dark';

// The logo's blue is 600, #2A63FD, so light mode's buttons are the logo's own colour.
export const BRAND_PALETTE: PaletteDesignToken = {
    50: '#F0F5FF',
    100: '#DEE9FF',
    200: '#C5D8FF',
    300: '#A2C0FF',
    400: '#709DFE',
    500: '#477DFF',
    600: '#2A63FD',
    700: '#1D4ED8',
    800: '#1841AF',
    900: '#1B3B8A',
    950: '#132654',
};
